var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model.latest_interaction)?_c('div',[_c('font-awesome-icon',{class:_vm.model.latest_interaction.color,attrs:{"icon":_vm.model.latest_interaction.icon}}),_vm._v(" "),_c('span',{class:_vm.model.latest_interaction.color},[_vm._v("\n            "+_vm._s(_vm.model.latest_interaction.label)+"\n        ")])],1):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }